export const SETTLEMENTREPORT_SHOW_RESET = 'SETTLEMENTREPORT_SHOW_RESET'
export const SETTLEMENTREPORT_SHOW_SET_ERROR = 'SETTLEMENTREPORT_SHOW_SET_ERROR'
export const SETTLEMENTREPORT_SHOW_SET_RETRIEVED = 'SETTLEMENTREPORT_SHOW_SET_RETRIEVED'
export const SETTLEMENTREPORT_SHOW_TOGGLE_LOADING = 'SETTLEMENTREPORT_SHOW_TOGGLE_LOADING'
